import Page from './index';

export default { path: '/home/tenant/tenantS3Admin', component: Page };
